export const momentFriendlyDateFormat = 'DD/MM/YYYY'
export const momentFriendlyDateUSFormat = 'MM/DD/YYYY'
export const momentFriendlyDateTimeFormat = 'DD/MM/YYYY HH:mm'
export const momentFriendlyDateTimeUSFormat = 'MM/DD/YYYY HH:mm'
export const momentFriendlyTimeFormat = 'HH:mm'
export const momentFriendlyMonthYearFormat = 'MM/YYYY'

export const momentBackDateFormat = 'YYYY-MM-DD'
export const momentBackDateTimeFormat = 'YYYY-MM-DD HH:mm:ss'
export const momentBackTimeFormat = 'HH:mm:ss'
export const momentBackMonthYearFormat = 'MM-YYYY'
